let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fGvTl")).then(() => parcelRequire('aHUge'));